import React from "react";
import Checkbox from "@mui/material/Checkbox";
import { CheckboxStyle } from './Component.style';

function CheckBox({ label, name, value, onChange, disabled, ...others }) {
  return (
      <CheckboxStyle
        control={<Checkbox name={name} checked={Boolean(value)} onChange={(e) => onChange(e.target.checked)} disabled={disabled} {...others} />}
        label={label}
      />
  );
}

export default CheckBox;
